import getCriticalError from './critical-error';

export default {
  getCriticalError,
};
